define('app/factories/vendor_rating_factory',['app/setup', 'app/views/vendor_rating_view', 'app/views/vendor_rating_landing_page_view','app/views/feedback_landing_page_view'],
  function(takhfifan, vendorRatingView) {
    $('.tkh-vendor-rating').each(function(){
      new takhfifan.VendorRatingView({
        el: $(this)
      });
    });

    $('.tkh-vr-landing-page').each(function(){
      new takhfifan.VendorRatingLandingPageView({
        el: $(this)
      });
    });
    $('.tkh-feedback-landing-page').each(function(){
      new takhfifan.FeedbackLandingPageView({
        el: $(this)
      });
    });
});


